module.exports = __webpack_public_path__ + "img/monovolume.9ef8f938.svg";